export const selectStyles = {
  control: (provided, state) => ({ ...provided, backgroundColor: '#FFF', border: '1px solid #DFDFDF', boxShadow: 'none', borderRadius: 20 }),
  placeholder: (provided, state) => ({ ...provided, color: '#000' }),
  indicatorSeparator: () => ({ display: 'none' }),
  option: (provided) => ({ ...provided, padding: '5px 10px' }),
};

export const ageStyles = {
  control: (provided, state) => ({ ...provided, backgroundColor: '#FFF', border: '1px solid #eee', boxShadow: 'none', borderRadius: 4, padding: 5 }),
  placeholder: (provided, state) => ({ ...provided, color: '#000' }),
  indicatorSeparator: () => ({ display: 'none' }),
  option: (provided) => ({ ...provided, padding: '5px 10px' }),
};

export const selectNumberStyles = {
  control: (provided, state) => ({ ...provided, backgroundColor: 'transparent', border: 'none', boxShadow: 'none', border: '1px solid #dfdfdf', padding: '0px 2px', minHeight: 24, color: state.isSelected ? '#0056b3' : '#333', ':hover': { borderColor: '#b3b3b3' } }),
  indicatorSeparator: (provided) => ({ ...provided, display: 'none' }),
  valueContainer: (provided) => ({ ...provided, fontSize: 14 }),
  dropdownIndicator: (provided) => ({ ...provided, padding: 0, cursor: 'pointer' }),
  menu:(provided) => ({ ...provided, display:"flex", justifyContent: 'center' }),
  menuList: (provided) => ({ ...provided, flexDirection: 'column', padding: 0 }),
  option: (provided, state) => ({ ...provided, padding: 5, backgroundColor: "transparent", color: state.isSelected ? '#0056b3' : '#333', cursor: 'pointer' }),
};

export const selectHeaderColumnStyles = {
  control: (provided, state) => ({ ...provided, backgroundColor: '#FFF', border: '1px solid #DFDFDF', boxShadow: 'none', borderRadius: 8,  width: 200, ':hover': { borderColor: '#b3b3b3' } }),
  placeholder: (provided, state) => ({ ...provided, color: '#000' }),
  indicatorSeparator: () => ({ display: 'none' }),
  option: (provided, state) => ({ ...provided, padding: '5px 10px', backgroundColor: "transparent", color: state.isSelected ? '#0056b3' : '#333', cursor: 'pointer' }),
};

export const selectLanguageStyles = {
  control: (provided, state) => ({ ...provided, backgroundColor: 'transparent', border: 'none', boxShadow: 'none',  }),
  indicatorSeparator: (provided) => ({ ...provided, display: 'none' }),
  dropdownIndicator: (provided) => ({ ...provided, padding: 0, cursor: 'pointer' }),
  menu:(provided) => ({ ...provided, display:"flex", justifyContent: 'center' }),
  singleValue: (provided) => ({ ...provided, color: '#fff' }),
  option: (provided, state) => ({ ...provided, padding: 5, backgroundColor: "transparent", color: state.isSelected ? '#0056b3' : '#333', cursor: 'pointer' }),
};
